import { RouterProvider } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
// import PwaRefreshPopup from './components/PwaRefreshPopup';
import router from '@/routes/router';
import { ToastProvider } from './context/ToastContext';

interface IProps {
  instance: PublicClientApplication;
}

function App({ instance }: IProps) {
  return (
    <>
      <MsalProvider instance={instance}>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </MsalProvider>
      {/* Enable this if registerType is not 'autoUpdate' and a refresh popup is required */}
      {/* <PwaRefreshPopup /> */}
    </>
  );
}

export default App;
